var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":_vm.transition,"tag":"div"}},_vm._l((_vm.fields),function(field){return _c('field',{key:'field-' + field.slug,attrs:{"field":field,"resource":_vm.resource,"tab":_vm.tab}})}))}
var staticRenderFns = []

export { render, staticRenderFns }